import { IPropertyPresentable, instanceOfIPropertyPresentable } from "./IPropertyPresentable";

export interface IPropertyEditable<T> extends IPropertyPresentable<T> {
  isEditable(): boolean;
  setValue(source: T): void;
}

export function instanceOfIPropertyEditable<T>(instance: any): instance is IPropertyEditable<T> {
  return instance
      && (instance.isEditable !== undefined)
      && (instance.setValue !== undefined)
      && instanceOfIPropertyPresentable<T>(instance);
}
